import { useEffect, useState } from 'react'
import Modal from '../../../../../components/Modal'
import Input from '../../../../../components/Input'
import DatePicker from '../../../../../components/DatePicker'
import RadioButton from '../../../../../components/RadioButton'
import { fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers'
import { useDispatch, useSelector } from '../../../../../store/store'
import styles from './style.module.scss';
import { errorMessages } from '../../../../../config/notification'
import { setAddEducationModal, setEducationEditMode, setSelectedEducation } from '../../../../../store/workspace/slice'
import Button from '../../../../../components/Button'
import { selectEducationEditMode, selectProfileData, selectSelectedEducation, selectUpdatingProfileData } from '../../../../../store/workspace/selectors'
import { v4 as uuid } from 'uuid';
import { updateProfileDataThunk } from '../../../../../store/workspace/thunks'
import DropDown from '../../../../../components/DropDown'
import { degreeList } from '../../../../../config'
import { ListItem } from '../../../../../store/signUp/types'

export default function AddEducation() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const editMode = useSelector(selectEducationEditMode);
    const isLoading = useSelector(selectUpdatingProfileData);
    const selectedEducation = useSelector(selectSelectedEducation);
    const [to, setTo] = useState(selectedEducation?.to || '');
    const [dateRangeError, setDateRangeError] = useState(false);
    const [GPA, setGPA] = useState(selectedEducation?.GPA || '');
    const [field, setField] = useState(selectedEducation?.field || '');
    const [from, setFrom] = useState(selectedEducation?.from || '');
    const [universityName, setUniversityName] = useState(selectedEducation?.universityName || '');
    const [didNotFinishDegree, setDidNotFinishDegree] = useState(selectedEducation && !selectedEducation.to ? true : false);
    const selectedDegree = selectedEducation ? (degreeList.find(i => i.title === selectedEducation.degree) || null) : null
    const [degree, setDegree] = useState<ListItem | null>(selectedDegree);

    useEffect(() => {
        return () => {
            dispatch(setEducationEditMode(false));
            dispatch(setSelectedEducation(null));
        }
    }, []);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;

        if (editMode) {
            const filteredList = profile.educationInfo.filter(i => i.id !== selectedEducation?.id);

            const record = {
                from,
                GPA,
                field,
                universityName,
                universityId: '-1',
                degree: degree?.title,
                id: selectedEducation?.id,
                to: didNotFinishDegree ? '' : to,
            };

            dispatch(updateProfileDataThunk({
                ...rest,
                educationInfo: [...filteredList, record]
            }));
        } else {
            const newRecord = {
                from,
                GPA,
                field,
                id: uuid(),
                universityName,
                universityId: '-1',
                degree: degree?.title,
                to: didNotFinishDegree ? '' : to,
            };

            dispatch(updateProfileDataThunk({
                ...rest,
                educationInfo: [...profile.educationInfo, newRecord]
            }));
        }
    };

    return (
        <Modal
            size='md'
            childClassName={styles.wrapper}
            title={editMode ? 'Edit degree' : 'Add degree'}
            closeFunc={() => dispatch(setAddEducationModal(false))}
        >
            <Input
                type='text'
                label='School or university'
                listIdKey='id'
                listTitleKey='title'
                value={universityName}
                onChange={setUniversityName}
            />
            <DropDown
                idKey='id'
                label='Degree'
                titleKey='title'
                setItem={setDegree}
                dropDownList={degreeList}
                selectedItem={degreeList.find(i => i.id === degree?.id)}
            />
            <Input
                type='text'
                value={field}
                onChange={setField}
                label='Field of study'
            />
            <Input
                type='text'
                value={`${GPA}`}
                // validation='GPA'
                inputMode='numeric'
                label='Overal result (GPA)'
                onChange={setGPA}
            />
            <div className={styles.date}>
                <RadioButton
                    text="Didn’t finish the degree"
                    checked={didNotFinishDegree}
                    setChecked={(val: boolean) => setDidNotFinishDegree(val)}
                />
                <div className={styles.date_fromTo}>
                    <DatePicker
                        label='From'
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(from)}
                        setSelectedDate={(val) => setFrom(fromDatePickerFormat(val))}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />
                    {!didNotFinishDegree && <DatePicker
                        label='To'
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(to)}
                        setSelectedDate={(val) => setTo(fromDatePickerFormat(val))}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />}
                </div>
                {dateRangeError && (<span className={styles.date_error}>{errorMessages.dateRange}</span>)}
            </div>
            <Button
                text='Save'
                type='Primary'
                onClick={submit}
                loading={isLoading}
                disabled={
                    !from ||
                    !field ||
                    !GPA ||
                    !universityName ||
                    (!didNotFinishDegree && !to)
                }
            />
        </Modal>
    )
}
